import { render } from "./SimpleTopbar.vue?vue&type=template&id=4cfa29c0&scoped=true"
import script from "./SimpleTopbar.vue?vue&type=script&lang=js"
export * from "./SimpleTopbar.vue?vue&type=script&lang=js"

import "./SimpleTopbar.vue?vue&type=style&index=0&id=4cfa29c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfa29c0"],['__file',"src/components/SimpleTopbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cfa29c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cfa29c0', __exports__)) {
    api.reload('4cfa29c0', __exports__)
  }
  
  module.hot.accept("./SimpleTopbar.vue?vue&type=template&id=4cfa29c0&scoped=true", () => {
    api.rerender('4cfa29c0', render)
  })

}


export default __exports__